import _get from 'lodash/get'

import {
    STUDENT_LOAN_SAVE_ERROR,
    STUDENT_LOAN_SAVE_SUCCESS,
    STUDENT_LOAN_SAVING,
    STUDENT_LOAN_UPDATE,
} from '../actions'

export default (
    state = {
        shouldFetch: true,
        fetchSuccessful: null,
        goToNextQuestion: false,
        goToNextAllowanceQuestion: false,
        isAllowanceUpdate: false,
        activeQuestionIndex: 0,
    },
    action
) => {
    switch (action.type) {
        case STUDENT_LOAN_UPDATE:
            return { ...state, ...action.studentLoan }

        case STUDENT_LOAN_SAVING:
            return { ...state, isSaving: true }

        case STUDENT_LOAN_SAVE_SUCCESS:
            return {
                ...state,
                ...action.studentLoan,
                isSaving: false,
                goToNextQuestion: !action.studentLoan.isAllowanceUpdate,
                goToNextAllowanceQuestion: action.studentLoan.isAllowanceUpdate,
                isAllowanceUpdate: false,
                saveError: false,
                errorMessage: '',
                validationErrors: null,
            }

        case STUDENT_LOAN_SAVE_ERROR:
            return {
                ...state,
                ...action.studentLoan,
                isSaving: false,
                goToNextQuestion: false,
                goToNextAllowanceQuestion: false,
                saveError: true,
                errorMessage: _get(action, ['errorResponse', 'message'], 'Unknown error occurred'),
                validationErrors: _get(action, ['errorResponse', 'modelState'], false),
            }

        default:
            return state
    }
}
